import { UpSeatLogo } from '@/assets/logos/upseat_logo'

import RedirectEngine from '@/services/Login/redirectEngine'
import { motion } from 'framer-motion'
import { Suspense, lazy } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

// Lazy load pages
const RequestTokenPage = lazy(() => import('@/pages/account/RequestToken'))
const VerifyTokenPage = lazy(() => import('@/pages/account/VerifyToken'))
const Wallet = lazy(() => import('@/pages/wallet'))
const ContentChannel = lazy(() => import('@/pages/contentChannel'))
const HelpCentre = lazy(() => import('@/pages/account/HelpCentre'))
const ResetPassword = lazy(() => import('@/pages/account/ResetPassword'))
const ForgotPassword = lazy(() => import('@/pages/account/ForgotPassword'))
const Home = lazy(() => import('@/pages/home'))
const LegalsCountries = lazy(() => import('@/pages/legals/LegalsCountries'))
const LegalsIndex = lazy(() => import('@/pages/legals/Legals'))
const TermsOfUse = lazy(() => import('@/pages/legals/TermsOfUse'))
const PrivacyPolicy = lazy(() => import('@/pages/legals/PrivacyPolicy'))
const CookiePolicy = lazy(() => import('@/pages/legals/CookiePolicy'))
const PasswordSetup = lazy(() => import('@/pages/account/PasswordSetup'))
const TeamLogin = lazy(() => import('@/pages/account/TeamLogin'))

const PublicRoutes = () => {
  return (
    <Suspense
      fallback={
        <motion.div
          initial={{ opacity: 0.01 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1, duration: 0.5 }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
          className="w-full h-[100svh] flex items-center justify-center pointer-events-none"
        >
          <span className="[&>svg]:w-[20vw] [&>svg]:h-[20vh]">
            <UpSeatLogo />
          </span>
        </motion.div>
      }
    >
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/u/:shortcode" element={<RedirectEngine />} />
        <Route path="/sign-up" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<RequestTokenPage />} />
        <Route path="/auth/verify" element={<VerifyTokenPage />} />
        <Route path="/tickets" element={<Wallet />} />
        <Route path="/channel/:id" element={<ContentChannel />} />
        <Route path="/help-centre" element={<HelpCentre />} />
        <Route path="/reset-my-password/:id" element={<ResetPassword />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/legals" element={<LegalsCountries />} />
        <Route path="/channel/:id" element={<ContentChannel />} />
        <Route
          path="/legals/terms"
          element={<Navigate to="/legals/uk/terms" replace />}
        />
        <Route
          path="/legals/privacy"
          element={<Navigate to="/legals/uk/privacy" replace />}
        />
        <Route
          path="/legals/cookies"
          element={<Navigate to="/legals/uk/cookies" replace />}
        />
        <Route path="/legals/:country" element={<LegalsIndex />} />
        <Route path="/legals/:country/terms" element={<TermsOfUse />} />
        <Route path="/legals/:country/privacy" element={<PrivacyPolicy />} />
        <Route path="/legals/:country/cookies" element={<CookiePolicy />} />
        <Route path="/password-setup" element={<PasswordSetup />} />{' '}
        <Route path="/team" element={<TeamLogin />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Suspense>
  )
}

export default PublicRoutes
